export const MNEMONIC_STORAGE_KEY = 'encrypted_mnemonic'
export const NSEC_STORAGE_KEY = 'encrypted_private_key'
export const LNURL_WATERMARKS_STORAGE_KEY = 'lnurlWatermarks'
export const LNURL_SENDS_STORAGE_KEY = 'lnurlSends'
